:host {
  display: block;
}

.lazy-img {
  width: 100%;
  height: auto;
  border: none;
  outline: none;
}